"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var utils_1 = require("./utils");
var FileListView_1 = require("./components/FileListView");
require("./style.scss");
var FileListOverview = (0, react_1.memo)(function (props) {
    var _a = (0, react_redux_1.useSelector)(function (state) { return ({
        router: state.router,
        files: state.files,
        viewport: state.viewport,
        bid: state.bid,
        token: state.auth.current.token,
        cart: state.cart
    }); }), router = _a.router, files = _a.files, viewport = _a.viewport, bid = _a.bid, token = _a.token, cart = _a.cart;
    var dispatchProps = (0, utils_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var stateProps = (0, utils_1.mapStateToProps)(router, files, viewport, bid, token, cart);
    var _b = (0, react_1.useState)([]), filteredAndSortedItems = _b[0], setFilteredAndSortedItems = _b[1];
    var _c = (0, react_1.useState)(0), totalResults = _c[0], setTotalResults = _c[1];
    var _d = (0, react_1.useState)([]), metaDataColumns = _d[0], setMetaDataColumns = _d[1];
    var internalProps = {
        filteredAndSortedItems: filteredAndSortedItems,
        setFilteredAndSortedItems: setFilteredAndSortedItems,
        totalResults: totalResults,
        setTotalResults: setTotalResults,
        metaDataColumns: metaDataColumns,
        setMetaDataColumns: setMetaDataColumns
    };
    var mergedProps = (0, react_1.useMemo)(function () { return (__assign(__assign(__assign(__assign({}, dispatchProps), stateProps), internalProps), props)); }, [props, internalProps, dispatchProps, stateProps]);
    var filteredMetadata = (0, react_1.useMemo)(function () { return mergedProps.fileList.filteredMetadataColumns; }, [mergedProps.fileList.filteredMetadataColumns]);
    (0, react_1.useEffect)(function () {
        mergedProps.onFetchProjects();
        if (mergedProps.currentProject && !mergedProps.currentBid) {
            mergedProps.fetchProjectFileListColumns(mergedProps.currentProject.id);
        }
        if (mergedProps.metadata.status === 'FETCHED') {
            (0, utils_1.initializeFilteredMetaData)(mergedProps.metadata, mergedProps.fileList, mergedProps.setMetaDataColumns);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        (0, utils_1.initializeFilteredMetaData)(mergedProps.metadata, mergedProps.fileList, mergedProps.setMetaDataColumns);
    }, [
        mergedProps.currentProject,
        mergedProps.metadata.status,
        filteredMetadata
    ]);
    (0, react_1.useEffect)(function () {
        if (mergedProps.data.status === 'FETCHED') {
            var sortByOptions = mergedProps.sortByOptions, searchOptions = mergedProps.searchOptions, files_1 = mergedProps.data.files, list = mergedProps.metadata.list;
            (0, utils_1.filterAndSortData)(sortByOptions, searchOptions, list, files_1, metaDataColumns, setTotalResults, setFilteredAndSortedItems);
        }
    }, [
        mergedProps.data.status,
        mergedProps.data.files,
        mergedProps.sortByOptions,
        mergedProps.searchOptions.toggleHideEmptyFolders,
        mergedProps.metaDataColumns
    ]);
    (0, react_1.useEffect)(function () {
        mergedProps.setPagingOptions(mergedProps)(0, mergedProps.sortByOptions.limit);
    }, [mergedProps.sortByOptions.filters]);
    (0, react_1.useEffect)(function () {
        if (mergedProps.currentProject &&
            mergedProps.fileBrowser.fileListWidth !== undefined &&
            mergedProps.fileBrowser.widthStatus === 'FETCHED') {
            mergedProps.saveFilelistWidth(mergedProps.currentProject.id, mergedProps.fileBrowser.fileListWidth, mergedProps.fileBrowser.fileListWidth >= 5 ? 'OPEN' : 'CLOSED');
        }
    }, [mergedProps.fileBrowser.fileListWidth, mergedProps.currentProject]);
    return React.createElement(FileListView_1.FileListView, __assign({}, mergedProps));
});
exports.default = FileListOverview;
